<template>
  <div style="background: url('../../static/img/login-bg.jpg') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;"
  class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group class="login-modal-card-group" no-border>
            <b-card @keyup.enter="submit" no-body class="p-4 login-modal-card">
              <b-card-body>
                <img src="/static/img/new-logo.png" height="40" width="130">
                <a href="javascript:void(0)" @click="backToLogin()" class="btn-close-modal"></a>
                <div class="login-modal-title-wrapper">
                  <h2 v-if="callStatus == 'send' || callStatus == 'sending'" class="login-modal-title login-modal-title--bold">
                    Reset your password
                  </h2>
                  <h2 v-if="callStatus == 'sent' || callStatus == 'sendAgain'" class="login-modal-title login-modal-title--bold">
                    Check your inbox
                  </h2>
                  <h2 v-if="callStatus == 'error'" class="login-modal-title login-modal-title--bold">
                    Error!
                  </h2>
                </div>

                <div v-if="callStatus == 'send' || callStatus == 'sending'" class="login-modal-text login-modal-text">
                  Enter your account email to receive a password reset link.
                </div>
                <div class="mb-4" v-else-if="callStatus == 'sent' || callStatus == 'sendAgain'">
                  <div class="login-modal-text login-modal-text--normal mb-1">
                    We have sent an email to {{email}} with a link to reset your password.
                  </div>
                  <div class="login-modal-text login-modal-text--normal">
                    It may take a few minutes for the email to arrive. If you don’t see anything after 10 minutes, check your junk or spam folder.
                  </div>
                </div>
                <p v-else-if="callStatus == 'error'" class="login-modal-text">
                  {{errormsg}}
                </p>

                <b-input-group v-if="callStatus === 'send' || callStatus === 'sending'" class="login-modal-form-input">
                  <input
                    type="email"
                    @keyup.enter="forgotSend"
                    @focus="sendAgain"
                    required=""
                    id="email"
                    aria-describedby="emailHelp"
                    placeholder="Email"
                    name="email"
                    v-model="email"
                    v-validate="'required|email'"
                    data-vv-delay="500"
                    class="form-control"
                  >
                </b-input-group>
                <p v-show="inputValidationErrors.has('email')" class="alert-text help is-danger-msg">{{ inputValidationErrors.first('email') }}</p>
                <!-- <small v-show="inputValidationErrors.has('email')" id="emailHelp" class="form-text text-muted">Please use your Masterworks email address</small> -->

                <div class="login-modal-footer login-modal-footer--no-border">
                  <b-button
                    type="submit"
                    v-if="callStatus == 'send'"
                    @click="forgotSend"
                    class="button-regular button-regular--send px-4 login-modal-btn login-modal-btn--bold login-modal-btn--full-width"
                    variant="primary"
                  >
                    Send Reset Link
                  </b-button>
                  <b-button
                    type="submit"
                    v-if="callStatus == 'sending'"
                    class="button-regular button-regular--sending px-4 login-modal-btn login-modal-btn--bold login-modal-btn--full-width"
                    variant="primary"
                  >
                    Sending...
                  </b-button>
                  <!-- <a v-if="callStatus == 'sending'" class="button-regular button-regular--send">Sending...</a> -->
                  <!-- <a v-if="callStatus == 'sent'" class="button-regular button-regular--send">Sent</a> -->
                  <b-button
                    type="submit"
                    v-if="callStatus == 'sent' || callStatus == 'sendAgain'"
                    @click="forgotSend"
                    class="button-regular button-regular--send px-4 login-modal-btn login-modal-btn--bold login-modal-btn--full-width"
                    variant="primary"
                  >
                    Resend Link
                  </b-button>
                  <b-button
                    type="submit"
                    v-if="callStatus == 'error'"
                    @click="tryAgain"
                    class="button-regular button-regular--send login-modal-btn login-modal-btn--bold login-modal-btn--full-width"
                  >
                    Try Again
                  </b-button>
                </div>

                <div class="login-modal-box--center" v-if="callStatus === 'sent' || callStatus === 'sendAgain' || callStatus === 'error'">
                  <div class="login-modal-text">
                    Having trouble?
                  </div>
                  <a
                    target="_blank"
                    href="mailto:lighthouse@alliesagainstslavery.org"
                    class="login-modal-text login-modal-text--link"
                  >
                    Contact Support
                  </a>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'forgotPassword',
  data () {
    return {
      dictionary: {
        custom: {
          loginemail: {
            required: () => 'Please enter the Email field.',
            email: () => 'Please enter a valid Email Id'
          }
        }
      },
      title: 'Please Enter Email Id to reset',
      email: '',
      error: '',
      callStatus: 'send',
      errormsg: ''
    }
  },
  mounted () {
  },
  methods: {
    tryAgain () {
      this.callStatus = 'send'
    },

    forgotSend () {
      this.$validator.validate().then(result => {
        var formDate = {
          email: this.email
        }
        if (result) {
          this.callStatus = 'sending'
          this.$store.dispatch('submitForgotPassword', formDate).then((response) => {
            if (this.submitNotification.status !== 200) {
              console.log('error')
              // Pop up the notification error
              this.callStatus = 'error'
              this.errormsg = this.submitNotification.body
            } else {
              this.callStatus = 'sent'
              // after reset all the fields vee validate will throw the errors for validation
              // so also clear the errors
              this.$validator.reset()
            }
          })
        }
      })
    },
    backToLogin () {
      this.$router.push({
        path: '/login'
      })
    },
    sendAgain () {
      if (this.callStatus === 'sent') {
        this.callStatus = 'sendAgain'
      }
    }
  },
  created () {
    console.log('Created...')
    this.$validator.localize('en', this.dictionary)
  },
  computed: {
    ...mapGetters({
      submitNotification: 'forgotPasswordResponse'
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.button-regular {
  width: 118px;
}
.alert-text {
  color: #B64242;
}
</style>



// WEBPACK FOOTER //
// src/views/pages/ForgotPassword.vue